var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 17V3C1.6 2.2268 2.2268 1.6 3 1.6H7C7.7732 1.6 8.4 2.2268 8.4 3V17C8.4 17.7732 7.7732 18.4 7 18.4H3C2.2268 18.4 1.6 17.7732 1.6 17Z",
    stroke: "#6B7280",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 7V3C11.6 2.2268 12.2268 1.6 13 1.6H17C17.7732 1.6 18.4 2.2268 18.4 3V7C18.4 7.7732 17.7732 8.4 17 8.4H13C12.2268 8.4 11.6 7.7732 11.6 7Z",
    stroke: "#6B7280",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 17V13C11.6 12.2268 12.2268 11.6 13 11.6H17C17.7732 11.6 18.4 12.2268 18.4 13V17C18.4 17.7732 17.7732 18.4 17 18.4H13C12.2268 18.4 11.6 17.7732 11.6 17Z",
    stroke: "#6B7280",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoard);
export default __webpack_public_path__ + "static/media/DashBoard.660df6a60895a890d2f2cd4844811d35.svg";
export { ForwardRef as ReactComponent };